// removed by extract-text-webpack-plugin
module.exports = {"the-news":"the-news","the-news-wrap-container":"the-news-wrap-container","the-news-wrap-item":"the-news-wrap-item"};


//////////////////
// WEBPACK FOOTER
// ./components/my-business/sub-view/the-news/style.scss
// module id = ./components/my-business/sub-view/the-news/style.scss
// module chunks = 0